import { render } from "./AutomationTemplateCard.vue?vue&type=template&id=4b1dbef0&scoped=true"
import script from "./AutomationTemplateCard.vue?vue&type=script&lang=js"
export * from "./AutomationTemplateCard.vue?vue&type=script&lang=js"

import "./AutomationTemplateCard.vue?vue&type=style&index=0&id=4b1dbef0&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1dbef0"]])

export default __exports__